import type { Dictionary } from './en'

export const fr = {
  nav: { features: 'Fonctions', pricing: 'Tarifs', faq: 'Questions', account: 'Mon compte', signIn: 'Se connecter' },

  hero: {
    title: 'Alt-Tab pour votre Mac',
    tagline: "macOS change d'application. AppSwitch fait changer ⌥Tab de fenêtre — toutes vos fenêtres, y compris les trois documents ouverts dans la même app.",
    download: 'Télécharger pour Mac',
    seePricing: 'Voir les tarifs',
    note: 'Gratuit · macOS 15 ou plus récent · Apple silicon et Intel',
    hint: 'Maintenez ⌥ et appuyez sur Tab — relâchez pour basculer',
  },

  features: {
    heading: 'Pensé pour ceux qui gardent vingt fenêtres ouvertes',
    sub: 'Une pression sur ⌥Tab les affiche toutes. Vous relâchez, vous y êtes.',
    items: [
      {
        title: 'Chaque fenêtre, pas chaque app',
        body: "Le sélecteur de macOS passe d'une application à l'autre. AppSwitch passe d'une fenêtre à l'autre — y compris les trois documents ouverts dans la même app.",
      },
      {
        title: "Le clavier d'abord",
        body: '⌥Tab pour avancer, ⌥⇧Tab pour reculer, les flèches pour se déplacer dans la grille. Relâchez ⌥ et la fenêtre choisie passe au premier plan.',
      },
      {
        title: 'Ne vole jamais le focus',
        body: "Votre app reste active tant que vous n'avez pas choisi. AppSwitch vit dans la barre des menus, sans icône dans le Dock pour vous encombrer.",
      },
      {
        title: 'Aperçus en direct',
        body: "Voyez le contenu réel de chaque fenêtre plutôt qu'une icône générique. Les fenêtres réduites apparaissent directement dans le sélecteur.",
      },
    ],
  },

  pricing: {
    heading: 'Achetez une fois. C\'est à vous.',
    sub: "Le sélecteur est gratuit et complet — ni période d'essai, ni version bridée. Pro ajoute les deux fonctions qui demandent une licence.",
    free: 'Gratuit',
    pro: 'Pro',
    ribbon: 'Achat unique',
    freePrice: '0 €',
    once: 'une fois',
    freeSub: "Tout ce qu'il faut pour arrêter d'utiliser ⌘Tab.",
    proSub: "Pas d'abonnement. Rien ne se renouvelle, jamais.",
    freeList: [
      'Sélecteur de fenêtres complet sur ⌥Tab',
      'Navigation au clavier et à la souris',
      'Affichage en grille ou en liste',
      'App de barre des menus, sans icône dans le Dock',
    ],
    proList: [
      'Tout ce que contient la version gratuite',
      'Aperçus en direct de chaque fenêtre',
      'Fenêtres réduites dans le sélecteur',
      'Deux Mac par licence',
    ],
    download: 'Télécharger',
    buy: 'Obtenir AppSwitch Pro',
    buyBusy: 'Ouverture du paiement…',
    freeFoot: 'Pas de compte. Pas de carte. Pas de date limite.',
  },

  faq: {
    heading: 'Questions',
    items: [
      {
        q: "Pourquoi AppSwitch a-t-il besoin de l'accès Accessibilité ?",
        a: "C'est la seule façon dont macOS permet à une app de capter ⌥Tab avant les autres, d'énumérer vos fenêtres et d'en ramener une au premier plan. Sans lui, l'app ne peut tout simplement pas fonctionner. Vous l'accordez vous-même dans les Réglages Système et pouvez le retirer à tout moment.",
      },
      {
        q: "Est-ce un abonnement ?",
        a: "Non. AppSwitch Pro est un achat unique. Rien ne se renouvelle, rien n'est prélevé à nouveau, et les mises à jour de la version majeure en cours sont incluses.",
      },
      {
        q: 'Sur combien de Mac puis-je l\'utiliser ?',
        a: "Deux par licence. Vous pouvez libérer une place à tout moment depuis votre espace compte ou depuis l'app : changer de machine ne demande jamais d'écrire au support.",
      },
      {
        q: 'Mes titres de fenêtres sont-ils envoyés quelque part ?',
        a: "Non. Aucun contenu de fenêtre, aucun titre et aucune frappe clavier ne quitte votre Mac. La seule requête réseau de l'app est la vérification de licence, et seulement si vous avez acheté Pro. La version gratuite ne touche jamais au réseau.",
      },
      {
        q: 'Quelles versions de macOS sont prises en charge ?',
        a: 'macOS 15 ou plus récent, sur Apple silicon comme sur Intel.',
      },
    ],
  },

  listMode: {
    heading: 'Deux façons de voir vos fenêtres',
    sub: 'On bascule depuis la barre des menus, ou avec la touche , pendant que le sélecteur est ouvert.',
    grid: { title: 'Grille, avec aperçus', body: 'Des vignettes du contenu réel. Idéal quand vous reconnaissez une fenêtre à ce qu’elle affiche.' },
    list: { title: 'Liste, avec titres complets', body: 'Une colonne dense où le titre entier de chaque fenêtre tient sur une ligne. Idéal pour vingt terminaux, ou des fichiers dont les noms ne diffèrent qu’à la fin.' },
  },

  footer: { terms: "Conditions générales", privacy: 'Politique de confidentialité' },

  consent: {
    text: "Nous utilisons Google Analytics pour savoir quelles pages sont utiles. Rien n'est mesuré sans votre accord. Voir notre",
    privacyLink: 'politique de confidentialité',
    accept: 'Accepter',
    decline: 'Refuser',
  },
} satisfies Dictionary
